
const version = '01.00'

const scripts = {ajvValidate: null, powtoonValidate: null}
const getScripts =  async () => {
  if (!scripts.ajvValidate ) {
    const [ajvValidation, {default: schema}, {validate: powtoonValidate}] = await Promise.all([
      import('../../utils/ajvValidation'),
      import('./schema/01.00.schema.json'),
      import('../../utils/powtoonValidation')
    ])
    scripts.ajvValidate = ajvValidation.createValidationForSchema(schema)
    scripts.powtoonValidate = powtoonValidate
    return scripts
  }
  else {return  scripts}
}
export const validate = async powtoon => {
  const validationScripts = await getScripts()
  const powtoonValidationErrors = validationScripts.powtoonValidate(powtoon)
  const ajvValidationErrors = validationScripts.ajvValidate(powtoon)

  if (!powtoonValidationErrors && !ajvValidationErrors) {
    console.log(`validation (${version}) finished without errors`)
    return null
  }

  console.log(`validation (${version}) errors found`)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content){
  if (!content.powtoon.exportAspectRatio){
    content.powtoon.exportAspectRatio = {
      method: 'none'
    }
  }
}
